const getGeneralResourceFile = require('utils/LanguageLocale').getGeneralResourceFile;
module.exports = function getResource(label, vars = []) {
    const getGeneralResource = getGeneralResourceFile();
    let resources = {
        aboutYouTitle: 'À propos de vous',
        aboutMeTitle: 'Ces informations optionnelles rendent votre avis encore plus utile pour les autres clients.',
        noteText: 'Sauf mention contraire, toute information que vous fournissez sera intégrée à votre profil public lorsque vous soumettez un commentaire.',
        termsOfUseLabel: 'Voir les conditions d’utilisation',
        postReviewLabel: 'Publier un commentaire',
        postErrorText: 'Une erreur s’est produite, veuillez ressayer plus tard',
        postedReviewMessageText: 'Les commentaires sont habituellement publiés dans les 72 heures suivant leur soumission; alors restez à l’écoute. Merci de nous aider à améliorer la communauté Sephora!',
        headlineLabel: 'Titre',
        optionalLabel: '(facultatif)',
        selectShadeTitle: 'Choisissez une teinte',
        writeYourReviewLabel: 'Rédiger votre commentaire',
        seeFullLabel: 'Voir en entier',
        'r&rGuidelinesLabel': 'Consulter les lignes directrices concernant les notes et évaluations',
        addPhotoLabel: 'Ajouter une photo',
        removePhotoLabel: 'Retirer la photo',
        imagesLimitLabel: '(jusqu’à deux images)',
        recommendThisProduct: 'Recommanderiez-vous ce produit?',
        continueShoppingLabel: 'Continuer à magasiner'
    };

    return resources[label] || getGeneralResource(label);
};
